import * as en from '@/locales/en-US';
import * as zh from '@/locales/zh-CN';
import { getLocale } from 'umi/locale';

function formatMessage({ id }) {
  if (getLocale() === 'zh-CN') {
    return zh.default[id] ? zh.default[id] : id
  } else if (getLocale() === 'en-US') {
    return en.default[id] ? en.default[id] : id
  } else {
    return null
  }
}
/**物流模式 */
export const LogisticMode = {
  UNIFY: {
    name: 'UNIFY',
    caption: formatMessage({ id: '统配' })
  },
  ONESTEPCROSS: {
    name: 'ONESTEPCROSS',
    caption: formatMessage({ id: '一步越库' })
  },
  TWOSTEPCROSS: {
    name: 'TWOSTEPCROSS',
    caption: formatMessage({ id: '二步越库' })
  }
};

/**作业模式 */
export const TaskType = {
  PICKING: {
    name: 'PICKING',
    caption: formatMessage({ id: '摘果' })
  },
  SOW: {
    name: 'SOW',
    caption: formatMessage({ id: '播种' })
  },
  PEND: {
    name: 'PEND',
    caption: formatMessage({ id: '悬挂称分播' })
  }
};
